/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_PauseInputs */

const en_options_pedal_action_pause = /** @type {(inputs: Options_Pedal_Action_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

const fr_options_pedal_action_pause = /** @type {(inputs: Options_Pedal_Action_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

const de_options_pedal_action_pause = /** @type {(inputs: Options_Pedal_Action_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

const it_options_pedal_action_pause = /** @type {(inputs: Options_Pedal_Action_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausa`)
};

const ru_options_pedal_action_pause = /** @type {(inputs: Options_Pedal_Action_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пауза`)
};

const es_options_pedal_action_pause = /** @type {(inputs: Options_Pedal_Action_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausa`)
};

const zh_cn2_options_pedal_action_pause = /** @type {(inputs: Options_Pedal_Action_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂停`)
};

const ja_options_pedal_action_pause = /** @type {(inputs: Options_Pedal_Action_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一時停止`)
};

const hi_options_pedal_action_pause = /** @type {(inputs: Options_Pedal_Action_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विराम`)
};

const pt_pt2_options_pedal_action_pause = /** @type {(inputs: Options_Pedal_Action_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausa`)
};

/**
* | output |
* | --- |
* | "Pause" |
*
* @param {Options_Pedal_Action_PauseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_pause = /** @type {((inputs?: Options_Pedal_Action_PauseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_PauseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_action_pause(inputs)
	if (locale === "de") return de_options_pedal_action_pause(inputs)
	if (locale === "it") return it_options_pedal_action_pause(inputs)
	if (locale === "ru") return ru_options_pedal_action_pause(inputs)
	if (locale === "es") return es_options_pedal_action_pause(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_action_pause(inputs)
	if (locale === "ja") return ja_options_pedal_action_pause(inputs)
	if (locale === "hi") return hi_options_pedal_action_pause(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_action_pause(inputs)
	return en_options_pedal_action_pause(inputs)
});